export enum ApiClientExceptionErrorCode {
  EmailUsed = 'EmailUsed',
  ServicePurchaseRequired = 'ServicePurchaseRequired',
  CouldNotAddClientToClass = 'CouldNotAddClientToClass',
  CouldNotCancelBooking = 'CouldNotCancelBooking',
  UserNotLoggedIn = 'UserNotLoggedIn',
  BadData = 'BadData',
  NotFound = 'NotFound',
  InvalidLoginCredentials = 'InvalidLoginCredentials',
  InvalidPassword = 'InvalidPassword',
  GiftCardBalanceMismatch = 'GiftCardBalanceMismatch',
  ClientMissingFromSite = 'ClientMissingFromSite',
  ClientMigrationFailed = 'ClientMigrationFailed',
  ClassRequiresPayment = 'ClassRequiresPayment',
}

export interface IApiClientException {
  Message: string;
  Code: number;
  ErrorCode: ApiClientExceptionErrorCode;
}
